import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, from, map, Observable, of } from 'rxjs';
import { PayerInvitationService } from 'src/app/dashboard/services/payer-invitation.service';

/**
 * Bloquea las páginas de pagadores si el cliente no está habilitado: el
 * operador le dio el permiso (`can_add_payers`) Y está APROBADO. Lo decide el
 * backend en vivo (`payer-link/acceso`) en cada entrada: no se confía en el
 * usuario del store, que puede estar viejo si el operador le quitó el permiso
 * con la sesión abierta.
 *
 * Sin aviso: un cliente no habilitado no ve nada de pagadores, ni siquiera un
 * "no disponible" que le cuente que la función existe. Ante cualquier error
 * se trata como no habilitado.
 */
@Injectable({ providedIn: 'root' })
export class CanAddPayersGuard implements CanActivate {
  constructor(
    private router: Router,
    private payerInvitations: PayerInvitationService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return from(this.payerInvitations.getAcceso()).pipe(
      map((acceso) => acceso?.habilitado === true),
      catchError(() => of(false)),
      map((habilitado) =>
        habilitado ? true : this.router.createUrlTree(['/wallet/home']),
      ),
    );
  }
}
